import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AvatarComponent } from '../avatar';

@Component({
    selector: 'vshc-active-user-info',
    templateUrl: './active-user-info.component.html',
    styleUrls: ['./active-user-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatButtonModule,
        MatIconModule,
        AvatarComponent
    ]
})
export class ActiveUserInfoComponent {

  avatarBackgroundColor = '#4c575c';
  avatarBoxShadow = '0 3px 1px -2px #0003, 0 2px 2px #00000024, 0 1px 5px #0000001f';

  @Input()
  name: string;

  @Input()
  email: string;

  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  translations: any;

  @Output()
  logout = new EventEmitter<void>();

}
